// extracted by mini-css-extract-plugin
export default {"top":"kwVzyJASm0AhlIp1cdrS","bottom":"fEycGYd_gAcocKsR30Kc"};